<div class="suggestion-card-content" ui-row uiAlign="top">
  <div class="icon-container" *ngIf="isIconAvailable" ui-col>
    <ng-content select="pi-card-icon"></ng-content>
  </div>
  <div class="sp-py-6" *ngIf="isStringText" ui-col uiFlex="1" data-test-id="suggestion-text-content">
    <span class="text-content" [ngClass]="fontColorClass">{{ textToDisplay }}</span>
  </div>

  <div class="sp-py-4 multi-text" *ngIf="!isStringText" ui-col uiFlex="1" data-test-id="suggestion-tags-text-content">
    <span class="text-content" *ngFor="let val of textToDisplay">{{ val }}</span>
  </div>
</div>
